import React from 'react';
import { DashboardLayout } from 'src/skins/venus/components/layouts';
import { BankTransferForm } from 'src/skins/venus/forms';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { VenusModal } from 'src/skins/venus/components/common';

const Wrapper = styled.div`
  section {
    margin: 0 0 2rem 0;
  }
`;

const BankTransfer = () => {
  const history = useHistory();
  return (
    <DashboardLayout>
      <VenusModal isOpen={true} closeModal={() => history.goBack()} fullheight={true} backgroundPage="dashboard">
        <Wrapper>
          <section>
            <BankTransferForm />
          </section>
        </Wrapper>
      </VenusModal>
    </DashboardLayout>
  );
};

export default BankTransfer;
